import { useState } from "react";
import styled from "styled-components";
import moment from "moment";
import { ChevronLeftIcon } from "icons/ArrowLeftIcon";
import { ChevronRightIcon } from "icons/ArrowLeftIcon";
import { useHistory } from "react-router-dom";

const CalendarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  padding: 8px 0;
  border-bottom: solid #e2e2ea;

  .chevron {
    display: flex;
    padding: 4px;
    align-items: center;
    gap: 8px;
    border-radius: 48px;
    border: 1px solid var(--Greyscale-Gray-10, #e2e2ea);
    background: #fff;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.06);
    cursor: pointer;

    &.right {
      position: absolute;
      right: -10px;
      top: 20;
    }

    &.left {
      position: absolute;
      left: -10px;
      top: 20;
    }
  }

  .monthLabel {
    position: absolute;
    left: 15px;
    top: -10px;
    font-size: 12px;
    color: #656575;
    font-weight: 500;
  }

  .calendarScroll {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-x: auto;
    scroll-behavior: smooth;
    gap: 8px;
    padding: 8px 0;
    transition: all 0.3s ease;

    ::-webkit-scrollbar {
      display: none;
    }
  }

  .dayBox {
    display: flex;
    width: 36px;
    padding: 4px;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    border-radius: 8px;
    background: #f8f8f8;
    transition: 0.3s;

    &.highlighted {
      border: 1px solid #149dff;
      background-color: #ebf6ff;
    }

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      background: #f0f0f0;
    }

    .day {
      font-weight: bold;
      font-size: 12px;
      color: #656575;
    }

    .date {
      margin-top: 4px;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
      color: #545454;
    }

    @media screen and (max-width: 768px) {
      width: 36px;
    }
  }
`;

const HorizontalCalendar = ({ actions, activeDate, setActiveDate }) => {
  const [currentWeek, setCurrentWeek] = useState(moment().startOf("week"));

  const getWeekDates = (startDate) => {
    const dates = [];
    for (let i = 0; i < 7; i++) {
      dates.push(moment(startDate).add(i, "days"));
    }
    return dates;
  };

  const scrollWeek = (direction) => {
    setCurrentWeek((prev) =>
      direction === "next"
        ? moment(prev).add(7, "days")
        : moment(prev).subtract(7, "days")
    );
  };

  const handleDateClick = (date) => {
    if (moment(date).isBefore(moment().startOf("day"))) {
      return;
    }
    setActiveDate(date.format("YYYY-MM-DD"));
  };

  const weekDates = getWeekDates(currentWeek);

  return (
    <CalendarContainer>
      <div className="monthLabel">{currentWeek.format("MMMM YYYY")}</div>
      <div className="chevron left" onClick={() => scrollWeek("prev")}>
        <ChevronRightIcon color="#7E7E8F" size={12} />
      </div>
      <div className="calendarScroll">
        {weekDates.map((date) => (
          <div
            key={date.format("YYYY-MM-DD")}
            className={`cursorPointer dayBox 
              ${activeDate === date.format("YYYY-MM-DD") ? "highlighted" : ""}
              ${date.isBefore(moment().startOf("day")) ? "disabled" : ""}
            `}
            onClick={() => handleDateClick(date)}
          >
            <div className="day l4">{date.format("ddd")}</div>
            <div className="date l3">{date.format("D")}</div>
          </div>
        ))}
      </div>
      <div className="chevron right" onClick={() => scrollWeek("next")}>
        <ChevronLeftIcon color="#7E7E8F" size={12} />
      </div>
    </CalendarContainer>
  );
};

export default HorizontalCalendar;
